import styled, { css } from 'styled-components'
import Icon from 'ui/components/Icon'
import { Transition } from 'utils/constants'

export const Wrapper = styled.div`
  padding: 24px 16px;
`
export const Elem = styled.a`
  height: 41px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 36px;
  user-select: none;
  transition: ${Transition.ms300} background-color;
  border-radius: 8px;
  --menu-icon-color: var(--menu-item-icon, var(--p-neutral-600));

  html[data-theme='dark'] & {
    --menu-icon-color: var(--p-neutral-600);
  }

  &:not(:last-child) {
    margin-bottom: 2px;
  }

  &:hover {
    background-color: var(--t-surface-1);
  }

  &[aria-selected='true'] {
    background-color: var(--t-surface-1);
  }
`

export const ProjectMenu = styled.div`
  margin-bottom: 16px;

  ${Elem} {
    color: var(--t-sidebar-text);

    &:hover {
      background-color: var(--t-project-menu-element-bg);
    }
    &[aria-selected='true'] {
      background-color: var(--t-project-menu-element-bg);
    }
    ${(p) =>
      p.$hide &&
      css`
        &:hover {
          background-color: var(--t-sidebar-button-bg);
        }

        &[aria-selected='true'] {
          background-color: var(--t-sidebar-button-bg);
        }
      `};
  }
`

export const ProjectMenuBox = styled.div`
  padding: 8px;
  background: var(--t-surface-block);
  border-radius: 8px;
`

export const ProjectMenuTitleStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

export const ProjectLogo = styled.div`
  width: 32px;
  height: 32px;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    border-radius: 50%;
  }
`

export const ProjectName = styled.div`
  width: calc(100% - 32px);
  font-size: 14px;
  font-weight: 500;
  padding-left: 8px;
  word-break: break-word;
`

export const ProjectMenuList = styled.div`
  position: relative;
`

export const List = styled.div`
  margin-bottom: 6px;
`

export const ControlIcon = styled.div`
  width: 18px;
  height: 18px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 12px;
  margin: auto;
  color: var(--menu-icon-color);

  svg {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
  }
`

export const IconImg = styled.img`
  width: 18px;
  height: 18px;
`

export const ControlTitle = styled.div`
  font-weight: 500;
`
export const ElemButton = styled.button`
  height: 41px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 36px;
  user-select: none;
  transition: ${Transition.ms300} background-color;
  border-radius: 8px;
  border: none;
  background: transparent;
  text-align: left;
  width: 100%;
  font: inherit;
  color: inherit;
  --menu-icon-color: var(--menu-item-icon, var(--p-neutral-600));
  html[data-theme='dark'] & {
    --menu-icon-color: var(--p-neutral-600);
  }

  &:not(:last-child) {
    margin-bottom: 2px;
  }

  &:hover {
    background-color: var(--t-surface-1);
  }
`

export const ChevronIcon = styled(Icon)`
  transition: transform ${Transition.ms200};
  transform: rotate(${({ $opened }) => ($opened ? '180deg' : '0deg')});
  margin-right: 12px;
`

export const ConfidentialityNotice = styled.div`
  font-size: 10px;
  text-align: center;
  color: var(--t-text-secondary);
`
